import React from 'react';
import SVG from 'react-inlinesvg';

import './_section-questions.scss';
import LOGO from "../../static/logo.svg";
import Slider from "react-slick";

const TestimonialItem = (props) => (
	<div>
	    <blockquote className="groucho">
	     {props.content}
	     <footer>{props.title}</footer>
	   </blockquote>
   </div>	
);

const QuestionItems = (props) => (
	<div className="col-md-4">
		<div className="question">
			<div className="h4">{props.title}</div>
			<p>{props.content}</p>
		</div>
	</div>
)

class NewsListing extends React.Component {
  	constructor(props) {
	        super(props);
	        	
	        }
  render() {
	  var settings = {
	      dots: true,
	      infinite: true,
	      speed: 500,
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      autoplay: true,
	    };
	  return (<section className="section-questions section-container" id="whyus" name="whyus">
  		<link rel="stylesheet" type="text/css" charSet="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
  		<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
    <div className="container">
	      <div className="row">
	        <div className="col-12 text-right">
	        	<h2>{this.props.data.title}</h2>
	        </div>
		</div>
		
		<div className="row">
		 {this.props.datab.parts.map((question, index) => {
		    return <QuestionItems 
		   	 title={question.title} 
		   	 content={question.content}
		     key={question.id}
		   	/>  
		 })}
		
			
		</div>
    </div>
  </section>)
  
	}
};

export default NewsListing;



// WEBPACK FOOTER //
// ./src/components/section-questions/index.js